export const techProviderRoutes = [
  {
    path: '/tech-provider/login',
    name: 'tech-provider-login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/tech-provider/signup',
    name: 'tech-provider-signup',
    component: () => import(/* webpackChunkName: "signup" */ '../views/SignUp.vue')
  },
  {
    path: '/tech-provider',
    name: 'my-listing-index',
    component: () => import(/* webpackChunkName: "PageWrapper" */ '../views/PageWrapper.vue'),
    children: [
      {
        path: '/tech-provider/my-listing',
        name: 'my-listing',
        component: () => import(/* webpackChunkName: "my-listing" */ '../views/private/MyListing.vue'),
        meta: {
          requiredAuth: true,
          role: '2'
        }
      },
      {
        path: '/tech-provider/my-listing-form',
        name: 'my-listing-form',
        component: () => import(/* webpackChunkName: "my-listing-form" */ '../components/my-listing/forms/Index.vue'),
        meta: {
          requiredAuth: true,
          role: '2'
        }
      },
      {
        path: '/tech-provider/dashboard',
        name: 'dashboard-index',
        component: () => import(/* webpackChunkName: "dashboard-index" */ '../views/Dashboard.vue'),
        meta: {
          requiredAuth: true,
          role: '2'
        },
        children: [
          {
            path: '/',
            name: 'dashboard',
            component: () => import(/* webpackChunkName: "dashboard" */ '../components/analytics/Dashboard.vue'),
            meta: {
              requiredAuth: true,
              role: '2'
            }
          },
          {
            path: '/active-promotions',
            name: 'active-promotions',
            component: () => import(/* webpackChunkName: "dashboard-active-promotions" */ '../components/analytics/ActivePromotions.vue'),
            meta: {
              requiredAuth: true,
              role: '2'
            }
          }
        ]
      },
      {
        path: '/tech-provider/rfps-messages',
        name: 'tech-rfps-messages',
        component: () => import(/* webpackChunkName: "rfps-messages" */ '../views/private/RfpsMessages.vue'),
        meta: {
          requiredAuth: true,
          role: '2'
        }
      },
      {
        path: '/tech-provider/rfp-list',
        name: 'tech-rfp-list',
        component: () => import(/* webpackChunkName: "buyer-rfp-list" */ '../views/private/TechRfpList.vue'),
        meta: {
          requiredAuth: true,
          role: '2'
        }
      },
      {
        path: '/tech-provider/bookmarks',
        name: 'tech-bookmarks',
        component: () => import(/* webpackChunkName: "bookmarks" */ '../views/private/Bookmarks.vue'),
        meta: {
          requiredAuth: true,
          role: '2'
        }
      },
      {
        path: '/tech-provider/account-settings',
        name: 'tech-account-settings',
        component: () => import(/* webpackChunkName: "tech-account-settings" */ '../views/private/AccountSettings.vue'),
        meta: {
          requiredAuth: true,
          role: '2'
        }
      },
      {
        path: '/tech-provider/support',
        name: 'tech-support',
        component: () => import(/* webpackChunkName: "support" */ '../views/private/Support.vue'),
        meta: {
          requiredAuth: true,
          role: '2'
        }
      }
    ]
  }
]
